<template>
    <div>
        <div v-if="initialLoad">
            <slot></slot>
        </div>
        <div v-else>
            <template v-if="currentPage > 1">
                <a :href="getUrl(1)" rel="start" class="search__ajax d-none d-inline-block-md" @click.prevent="changePage(1)">
                    <i class="fi-left-open"></i> First
                </a>
                <a :href="getUrl(currentPage - 1)" rel="prev" class="search__ajax d-inline-block" @click.prevent="changePage(currentPage - 1)">
                    {{ currentPage - 1 }}
                </a>
            </template>

            <div class="search__ajax search__ajax--current-page">
                {{ currentPage }}
            </div>

            <template v-if="currentPage < totalPages">
                <a :href="getUrl(currentPage + 1)" rel="next" class="search__ajax d-inline-block" @click.prevent="changePage(currentPage + 1)">
                    {{ currentPage + 1 }}
                </a>
                <a :href="getUrl(totalPages)" class="search__ajax d-none d-inline-block-md" @click.prevent="changePage(totalPages)">
                    Last <i class="fi-right-open"></i>
                </a>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import generateSearchUrl from '../../modules/generateSearchUrl';

export default defineComponent({
    props: {
        url: {type: String, required: true},
        currentSort: {type: String, required: true},
        currentPage: Number,
        totalPages: Number,
        initialLoad: Boolean,
    },
    methods: {
        changePage(page: number) {
            this.$emit('navigate', page);
        },
        getUrl(page: number) {
            return generateSearchUrl(this.url, page, this.currentSort);
        },
    },
});
</script>
